import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Chapter } from "./Reveal";

const FAQS = [
  {
    q: "Cosa include esattamente il prezzo di 997€/anno?",
    a: "Include uno shooting fotografico dedicato alla tua attività, 3 contenuti pronti da postare ogni mese, l'assistente AI Mirlo IA in collaborazione con Miriana Lomartire, 10 idee extra da realizzare in autonomia al mese, manuali e guide per vendere di più online. Per 365 giorni, hai il tuo marketing online che funziona ad un costo più che conveniente.",
  },
  {
    q: "Ci sono rinnovi automatici o vincoli?",
    a: "No. L'abbonamento dura 365 giorni e non si rinnova in automatico: alla scadenza decidi tu, liberamente, se continuare con noi.",
  },
  {
    q: "Come funziona lo shooting fotografico?",
    a: "Un fotografo professionista concorda con te data e location (presso la tua sede, il tuo negozio o studio) e realizza, in un unico incontro, gli scatti che alimenteranno i tuoi contenuti social tutto l'anno. Lo shooting incluso si svolgerà una sola volta e verrà fissato a pochi giorni dalla sottoscrizione dell'abbonamento. Qualora necessitassi di un secondo shooting durante l'anno, potrai prenotarlo in app.",
  },
  {
    q: "Non so usare i social: va bene lo stesso?",
    a: "È fatto apposta per te. Le guide pratiche e Mirlo IA ti accompagnano passo passo: dalle idee, ai testi, fino alla pubblicazione. In pochi minuti a settimana.",
  },
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-3xl px-5 py-12">
    <Chapter number="06" label="Domande frequenti" />
    <Reveal>
      <h2 className="text-center font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">Domande frequenti</h2>
      <Accordion type="single" collapsible className="mt-6" data-testid="faq-accordion">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-heading text-base font-semibold text-slate-900">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-slate-600">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
